import { localize } from "render/context/InternationalizationContext";

export const CopiedToClipboard = localize({
  en_GB: "Copied to clipboard",
  sv_SE: "Kopierat till urklipp",
});
